import { map } from "rxjs/operators";

import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Service } from "@angular/core";

import { environment } from "../../../../environments/environment";
import { type IBaseResponse } from "../../../shared/interfaces/IBaseResponse";
import { type INotificationInbox } from "../interfaces/notification.model";

@Service()
export class NotificationInboxService {
  private readonly http = inject(HttpClient);

  getInbox(
    tenant: string,
    pageIndex = 0,
    pageSize = 20,
    isRead: boolean | null = null
  ) {
    let params = new HttpParams()
      .set("pageIndex", pageIndex)
      .set("pageSize", pageSize);
    if (isRead !== null) {
      params = params.set("isRead", isRead);
    }
    return this.http
      .get<IBaseResponse & { data: INotificationInbox }>(
        `${environment.API_URL}/api/notifications/${tenant}`,
        { params }
      )
      .pipe(map(r => r.data));
  }

  getUnreadCount(tenant: string) {
    return this.getInbox(tenant, 0, 1, false).pipe(
      map(r => r.pagination.totalCount)
    );
  }

  markAsRead(tenant: string, deliveryId: number) {
    return this.http.post<IBaseResponse & { data: null }>(
      `${environment.API_URL}/api/notifications/${tenant}/deliveries/${deliveryId}/read`,
      {}
    );
  }
}
